import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SdHeadingComponent } from '@sdvor/seo/ui';
import { OrderDocumentsComponent } from '../../components';

@Component({
  selector: 'sd-order-documents-page',
  templateUrl: './order-documents.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [OrderDocumentsComponent, SdHeadingComponent],
})
export class OrderDocumentsPageComponent {}
